import { AppDispatch } from "../../../store";
import { RootState } from "../../../store/types";
import { connect } from "react-redux";
import CurrentPlanSummary from "./index";
import { GetShiftPlanOutputRequest } from "../../reviewAndPublish/model";
import { getShiftPlanOutputThunk } from "../../../store/slices/reviewAndPublishSlice";
import { SPMSGetShiftPlanResponse } from "../../../types/shiftPlan";
import { showError } from "../../../store/slices/errorSlice";

// Define the props that come directly from parent (not from Redux)
interface OwnProps {
    shiftPlans: SPMSGetShiftPlanResponse[];
    selectedTab: string;
    selectedDate: string;
    selectedShift: string;
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
    shiftPlans: ownProps.shiftPlans, // Pass through the shiftPlans from parent
    selectedDate: ownProps.selectedDate,
    selectedShift: ownProps.selectedShift,
    planId: state.shiftPlan.planId,
    stationCode: state.shiftPlan.stationCode,
    shiftPlanOutput: state.reviewAndPublish.shiftPlanOutput
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    getShiftPlanOutput: (getShiftPlanOutputRequest: GetShiftPlanOutputRequest) => dispatch(getShiftPlanOutputThunk(getShiftPlanOutputRequest)),
    showError: (errorPayload: { title: string; message: string }) => dispatch(showError(errorPayload))
});

export default connect(mapStateToProps, mapDispatchToProps)(CurrentPlanSummary);
